import { createSelector, createFeatureSelector } from '@ngrx/store';
import { getTotalAccountCount } from '../util/accounts.util';
import { AccountsState } from './accounts.reducer';
import { selectIsMobileAppEnabled } from '../../../store/selectors/feature-flag.selector';

export const selectAccountsState = createFeatureSelector<AccountsState>('accounts');

// Accounts
export const selectAccounts = createSelector(selectAccountsState, (state) => state?.accounts);
export const selectAccountsLoading = createSelector(selectAccountsState, (state) => state?.loading);
export const selectAccountsLoaded = createSelector(selectAccountsState, (state) => state?.loaded);

// Errors
export const selectGatewayError = createSelector(selectAccountsState, (state) => state?.gatewayError);
export const selectLoanError = createSelector(selectAccountsState, (state) => state?.loanError);
export const selectCreditCardError = createSelector(selectAccountsState, (state) => state?.creditCardError);
export const selectBechError = createSelector(selectAccountsState, (state) => state?.bechError);

// Util
export const selectIsCardOnlyUser = createSelector(selectAccounts, (accounts) => {
  if (!accounts) {
    return false;
  }
  return !accounts.loanAccounts?.[0]?.accountDetailsList?.length && !!accounts.cardAccounts?.length;
});
export const selectLoanAccountPastDue = createSelector(selectAccounts, (accounts) => accounts?.pastDueLoanAccount);
export const selectHasCardAccountPastDue = createSelector(
  selectAccounts,
  (accounts) => accounts?.hasPastDueCardAccount
);
export const selectHasAccountPastDue = createSelector(
  selectLoanAccountPastDue,
  selectHasCardAccountPastDue,
  (loanPastDue, hasCardPastDue) => !!loanPastDue || hasCardPastDue
);
export const selectIsBEFHOnlyCustomer = createSelector(selectAccountsState, (state) => {
  if (!state || !state.accounts) {
    return undefined;
  } else if (state.loanError || state.creditCardError) {
    return false;
  } else {
    const accountCount = getTotalAccountCount(state.accounts);
    return accountCount === 1 && !!state.accounts?.bechAccounts.length && !!state.accounts.bechAccounts[0]?.url;
  }
});

export const hasOpenLoanAccount = createSelector(
  selectAccounts,
  (accounts) => !!accounts?.loanAccounts[0]?.accountDetailsList?.some((account) => account?.accountStatus !== 'Closed')
);

export const displayMobileCard = createSelector(
  hasOpenLoanAccount,
  selectIsMobileAppEnabled,
  (hasOpenLoanAccount, isMobileAppEnabled) => hasOpenLoanAccount && isMobileAppEnabled
);
